export const DEFAULT_LABELS_VARIANT = 'default_v1';

export const KNOWN_LABELS_VARIANTS = Object.freeze([
    'legal_pro_v1',
    'entrepreneur_v1',
    'sme_ops_v1',
    DEFAULT_LABELS_VARIANT,
]);

const KNOWN_LABELS_VARIANTS_SET = new Set(KNOWN_LABELS_VARIANTS);

export const RENDERING_I18N_KEY_TO_LABEL_KEY = Object.freeze({
    'ai_comment_detail.memo_labels.legal_mechanism': 'mechanism',
    'ai_comment_detail.memo_labels.litigation_exposure': 'litigationRisk',
    'ai_comment_card.qualification': 'qualification',
    'ai_comment_card.legal_references': 'references',
});

const getDefaultValue = (fallbackOrOptions) => {
    if (typeof fallbackOrOptions === 'string') return fallbackOrOptions;
    if (
        fallbackOrOptions &&
        typeof fallbackOrOptions === 'object' &&
        typeof fallbackOrOptions.defaultValue === 'string'
    ) {
        return fallbackOrOptions.defaultValue;
    }
    return undefined;
};

export function normalizeLabelsVariant(value) {
    const normalized = String(value || '').trim();
    return KNOWN_LABELS_VARIANTS_SET.has(normalized)
        ? normalized
        : DEFAULT_LABELS_VARIANT;
}

export function translateRenderingLabel(t, labelsVariant, labelKey, fallback) {
    const variant = normalizeLabelsVariant(labelsVariant);
    const defaultLabel = t(
        `ai_comment_rendering_labels.${DEFAULT_LABELS_VARIANT}.${labelKey}`,
        fallback || labelKey
    );

    return t(`ai_comment_rendering_labels.${variant}.${labelKey}`, defaultLabel);
}

export function createRenderingT(t, labelsVariant) {
    return (key, fallbackOrOptions, ...rest) => {
        const labelKey = RENDERING_I18N_KEY_TO_LABEL_KEY[key];
        if (!labelKey) {
            return t(key, fallbackOrOptions, ...rest);
        }

        return translateRenderingLabel(
            t,
            labelsVariant,
            labelKey,
            getDefaultValue(fallbackOrOptions) || key
        );
    };
}
